import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Styles from "../Styles/Common.module.css";
import Button from "../Styles/Button.module.css";
import "./EventDetail.css";
import AddGuestModal from "./AddGuestModal";
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { FaCalendarDays } from "react-icons/fa6";
import { LuClock9 } from "react-icons/lu";
import { IoLocationSharp } from "react-icons/io5";
import { MdCurrencyRupee } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import { FaCalendarAlt, FaMapMarkerAlt, FaRupeeSign } from "react-icons/fa";
import {
  FaTwitter,
  FaWhatsapp,
  FaLinkedinIn,
  FaFacebookF,
} from "react-icons/fa6";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
import ReactPlayer from "react-player";
import {
  getEventsDetailFormData,
  saveEventAttendence,
  createRegistrationData
} from "../../services/routes.services";
import constants from "../../services/constants";
import parse from "html-react-parser";
import LoginPopup from "../Common/Login/UserLogin";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import ReviewRegistrationPopup from "./ReviewRegistrationPopup";
import axios from "axios";
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  const dayWithSuffix =
    day +
    (day % 10 === 1 && day !== 11
      ? "st"
      : day % 10 === 2 && day !== 12
      ? "nd"
      : day % 10 === 3 && day !== 13
      ? ""
      : "");
  return `${dayWithSuffix} ${month} ${year}`;
};
const dayOfWeek = (dateString) => {
  const date = new Date(dateString);
  const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
  return `${dayOfWeek}`;
};
const EventDetailPage = () => {
  const [loginShow, setLoginShow] = useState(false);
  const [eventDetailData, setEventDetailData] = useState(null);
  const [eventOtherData, setEventOtherData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedAttendance, setSelectedAttendance] = useState("Will Attend");
  const [showAttendenceCard, setAttendenceCard] = useState(false);
  const [showRegistrationCard, setShowRegistrationCard] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserType, setSelectedUserType] = useState("");
  const [memberShipprice, setMemberShipprice] = useState("");
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [attendance, setAttendance] = useState(null);
  const [error, setError] = useState(null);
  const [eventId, setEventId] = useState(null);
  const [relatedEvent, setRelatedEvent] = useState([]);
  const { isAuthenticated, user, token } = useSelector((state) => state.auth);
const [form, setForm] = useState({
  amount: '',
  productinfo: '',
  firstname: '',
  email: '',
  phone: ''
});
  const { url } = useParams(); // Extract `id` from the URL
  // useEffect(() => {
  //   const fetchAttendance = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${constants.API_BASE_URL}event/attendance/${eventId}/${user._id}`
  //       );
  //       setAttendance(response.data.data);
  //       localStorage.setItem('userAttendence', response.data.data.attendance);
  //     } catch (err) {
  //       setError(err.response?.data?.message || "Something went wrong");
  //     }
  //   };

  //   fetchAttendance();
  // }, [eventId, user._id]);
  useEffect(() => {
    if (!eventDetailData || !eventDetailData._id || !user?._id) return;
  
    const fetchAttendance = async () => {
      try {
        const response = await axios.get(
          `${constants.API_BASE_URL}event/attendance/${eventDetailData._id}/${user._id}`
        );
        console.log(response.data.data,"attendent")
        setAttendance(response.data.data);
        localStorage.setItem('userAttendence', response.data.data.attendance);
      } catch (err) {
        setError(err.response?.data?.message || "Something went wrong");
      }
    };
  
    fetchAttendance();
  }, [eventDetailData, user?._id]);
  useEffect(() => {
    getEventsDetailFormData(url)
      .then((res) => {
        const eventData = res.data.events[0];
        const eventOtherData1 = res.data.otherData;
        setEventDetailData(eventData);
        setEventId(eventData._id)
        setEventOtherData(eventOtherData1);

        localStorage.setItem('registrationChargeDetail',JSON.stringify({'spouseCharges':eventData.spouseFee,'guestCharges':eventData.guestFee,'eventDetail':eventData}))

      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  if (!eventDetailData) {
    return <p>Loading...</p>; // Show a loading message while data is fetched
  }
  const currentUrl = encodeURIComponent(window.location.href); // Fetch and encode the current browser URL
  
  const handleConfirmAttendance = (e) => {
    e.preventDefault();
     if(isAuthenticated === true){
             setShowModal(true);
        }
        if(isAuthenticated === false){
            setLoginShow(true)
        }
   
  };
  const handleRegistration = (e) => {
    e.preventDefault();
     if(isAuthenticated === true){
            setShowRegistrationCard(true);
        }
        if(isAuthenticated === false){
            setLoginShow(true)
        }
    
  };
 const loginCloseHandler = ()=>{
            setLoginShow(false)
    }
  const closeModal = (e) => {
    e.preventDefault();
    setShowRegistrationCard(false);
  };
  const handleUserTypeClick = (userType,price) => {
    // console.log(`Selected User Type: ${userType}`);
    setSelectedUserType(userType);
    setMemberShipprice(price)
    setForm((prev) => ({
    ...prev,
    amount: price,
    productinfo: eventDetailData?._id || '' // replace this with actual event ID
  }));
    // setIsModalOpen(true);
    localStorage.setItem('memberShipDetail',JSON.stringify({'userType':userType,'memberShipCost':price}))
    // Perform any action based on the user type
  };
const handleChange = (e) => {
  const { name, value } = e.target;
  setForm((prev) => ({
    ...prev,
    [name]: value
  }));
};
  const handleAttendance = async (status) => {
    console.log(status,"status")
    if(!user){
      toast.error('Please Login!', {
        position: "top-right",
        autoClose: 2000,
        type: "error",
      });
      return false;
    }
    setSelectedAttendance(status);
    let formData = new FormData();
    formData.append("eventId", eventDetailData._id);
    formData.append("userId", user._id);
    formData.append("attendance", status);
    const response = await saveEventAttendence(formData, token);
    
    //console.log(response);
    if (response.success === false) {
      //setAttendenceCard(true);
      //alert(response.message);
      toast.error(response.message, {
        position: "top-right",
        autoClose: 2000,
        type: "error",
      });
    } else {
      //setAttendenceCard(true);
      localStorage.setItem('userAttendence', status);
      toast.success(response.message, {
        position: "top-right",
        autoClose: 2000,
        type: "success",
      });
    }

    setShowModal(false); // Close the modal
    // Add your logic to handle the attendance status, e.g., API call
  };
  // Handle the Submit button click
  const handleSubmit = () => {
    //alert(1);'
    setIsPopupVisible(true); // Show the popup
  };

  // Handle closing the popup (if needed)
  const closePopup = () => {
    setIsPopupVisible(false); // Hide the popup
  };
    const currentDate = new Date();
  let filterReltedEvents = [];
  if (relatedEvent.length > 0) {
    const futureEvents = relatedEvent.filter(event => new Date(event.eventDate) < currentDate);
    filterReltedEvents = futureEvents;
  }

  const showReltedEvent = filterReltedEvents.filter(item => item.eventSlug !== url);

  // console.log(eventDetailData);
  
    let postEventData = [];
if (eventDetailData.length > 0) {
    const futureEvents = eventDetailData.filter(event => new Date(event.eventDate) < currentDate);
    if (futureEvents.length > 0) {
        postEventData = futureEvents;
    }
}
const enddate1 = new Date(eventDetailData.endDate); // Converts string to Date object


 
  const filterEventData = eventOtherData?.filter((otherData) => otherData.TypeId === "1");
  const filterVideoData = eventOtherData?.filter((otherData) => otherData.TypeId === "2"); 
  const filterSponsorsData = eventOtherData?.filter((otherData) => otherData.TypeId === "3");  
  const filterSpeakersData = eventOtherData?.filter((otherData) => otherData.TypeId === "4");
  const filterModeratorData = eventOtherData?.filter((otherData) => otherData.TypeId === "5"); 
  const smoothScroll = () => {
    window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
    });
};
const handleSubmitRegister = (e) => {
  e.preventDefault();

  const { amount, productinfo, firstname, email, phone } = form;

  // Simple validation check
  if (!amount || !productinfo || !firstname || !email || !phone) {
    alert("Please select the amount & fill all fields.");
    return;
  }
// Format data as x-www-form-urlencoded
  const body = new URLSearchParams();
  body.append('amount', amount);
  body.append('productinfo', productinfo);
  body.append('firstname', firstname);
  body.append('email', email);
  body.append('phone', phone);
  

  // Example: Call your API here
  createRegistrationData(body, token)
 .then(res => {
   
if(res.status==200){
  

        // Open payment URL in a new tab
        const paymentUrl = `https://pay.easebuzz.in/pay/${res.data.data}`;
        window.open(paymentUrl, '_blank');
}
   
  }).catch(err => {
    console.error(err);
  });
};
const speakerData = eventOtherData?.filter(item => item.TypeId === '4');
const moderatorData = eventOtherData?.filter(item => item.TypeId === '5');
const eventVideoData = eventOtherData?.filter(item => item.TypeId === '2');
  return (
    <div>
      {eventDetailData && (
        <>
          <BreadcrumbComponent home="Home" listOne="Event Detail" />
          <div className={Styles.eventDetailPaage}>
            <div className={Styles.detailBanner}>
              <Container>
                <Row>
                  <Col>
                    <div className={Styles.content}>
                      <span>MAAD WEBINAR</span>
                      <h1>{eventDetailData.title}</h1>
                      {/* <p>The 8th edition of the MAAD-Mayo OBS Interactive webinar</p> */}
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className={Styles.eventMainImg}>
              {eventDetailData.image !== "null" && (
                <img
                  src={constants.IMAGE_BASE_URL + "event/thumb/" + eventDetailData.image}
                />
              )}
            </div>
            <div className={Styles.eventTimeing}>
              <Container>
                <Row>
                  <Col md={5} className={Styles.timePadd}>
                    <div className={Styles.timeBox}>
                      <h2>Start Date & Time</h2>
                      <div className={Styles.timeElem}>
                        <div className={Styles.timeLeft}>
                          <p>
                            <FaCalendarDays className={Styles.timeIcon} />{" "}
                            {formatDate(eventDetailData.eventDate)}{" "}
                            <span>|</span>{" "}
                            {dayOfWeek(eventDetailData.eventDate)}
                          </p>
                        </div>
                        <div className={Styles.timeLeft}>
                          <p>
                            <LuClock9 className={Styles.timeIcon} />
                            {eventDetailData.startTime}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={Styles.timeBox}>
                      <h2>End Date & Time</h2>
                      <div className={Styles.timeElem}>
                        <div className={Styles.timeLeft}>
                          <p>
                            <FaCalendarDays className={Styles.timeIcon} />{" "}
                            {formatDate(eventDetailData.endDate)} <span>|</span>{" "}
                            {dayOfWeek(eventDetailData.endDate)}
                          </p>
                        </div>
                        <div className={Styles.timeLeft}>
                          <p>
                            <LuClock9 className={Styles.timeIcon} />
                            {eventDetailData.endTime}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={Styles.timeBox +" " + Styles.addresBox}>
                      <div className={Styles.timeElem}>
                        <div className={Styles.timeFlex}>
                          <h2>Address</h2>
                          <p>
                            <IoLocationSharp className={Styles.timeIcon} />{" "}
                            {eventDetailData.address}
                          </p>
                        </div>
                        <div className={Styles.timeFlex}>
                          <h2>City</h2>
                         {eventDetailData.city && <p>
                            <IoLocationSharp className={Styles.timeIcon} />{" "}
                            {eventDetailData.city.name}
                          </p>}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col md={4} className={Styles.timnepaddLeft}>
                    <div className={Styles.timeBox}>
                      <h2>Contribution per person</h2>
                      <div className={Styles.timeElem}>
                      <ul>
                          <li>
                            Student{" "}
                            <span>
                              <MdCurrencyRupee className={Styles.timeIcon} />{" "}
                              {eventDetailData.studentFee}
                            </span>
                          </li>
                          <li>
                            Life Member Alumni{" "}
                            <span>
                              <MdCurrencyRupee className={Styles.timeIcon} />{" "}
                              {eventDetailData.lifeMemberFee}
                            </span>
                          </li>
                          <li>
                            Non-Life Member Alumni{" "}
                            <span>
                              <MdCurrencyRupee className={Styles.timeIcon} />{" "}
                              {eventDetailData.nonLifeMemberFee}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col md={3}>
                    {showAttendenceCard && (
                      <div className="event-card">
                        {/* Header Section */}
                        <div className="event-header">
                          <h4 className="event-title">
                            {eventDetailData.title}
                          </h4>
                        </div>

                        {/* Content Section */}
                        <div className="event-content">
                          {/* Left Side: Event Details */}
                          <div className="event-details">
                            <p className="event-date">
                              <FaCalendarAlt className="icon" />{" "}
                              {formatDate(eventDetailData.eventDate)}
                            </p>
                            <p className="event-location">
                              <FaMapMarkerAlt className="icon" />{" "}
                              {eventDetailData.address}
                            </p>
                            <p className="event-price">
                              <FaRupeeSign className="icon" /> {"1000"}
                            </p>
                          </div>

                          {/* Right Side: Attendance Status */}
                          <div className="attendance-status">
                            <span className="status-dot"></span>
                            <span className="status-text">
                              {selectedAttendance}
                            </span>
                          </div>
                        </div>

                        {/* Footer Section */}
                        <button className="register-button">
                          REGISTER NOW
                        </button>
                      </div>
                    )}
                  {enddate1 >= currentDate &&
                    <div className={Styles.timeReg}>
                     {!attendance && (
                        <Link onClick={handleConfirmAttendance}>
                          Confirm Attendance
                        </Link>
                       )} 
                      {attendance && (
                         <Link 
                        >{attendance && attendance.attendance}</Link>
                      )}
                      <Link onClick={handleRegistration}>REGISTRATION</Link>
                    </div>
                  }
                  </Col>
                </Row>
              </Container>
            </div>
            <div className={Styles.eventDetailSec}>
              <Container>
                <Row>
                  <Col md={9} className={Styles.wid100}>
                    <div className={Styles.AllTypecontent}>
                      {eventDetailData.description === 'null' ? null : parse(`${eventDetailData.description}`)}
                     
                      <>
                        {filterEventData && filterEventData.length > 0 && (
                          <div className={`${Styles.galleryBlock} ${Styles.blockSpace}`}>
                            <h2>Event Gallery</h2>
                            <div className={Styles.galeryContainer}>
                              {filterEventData.map((otherData) => (
                                <figure key={otherData._id}>
                                  <img 
                                    src={`${constants.IMAGE_BASE_URL}/event/${otherData.image}`} 
                                    alt={otherData.title || "Event Image"} 
                                  />
                                </figure>
                              ))}
                            </div>
                          </div>
                        )}
                      </>
                      <>
                      {filterSponsorsData && filterSponsorsData.length > 0 &&(
                        <div className={Styles.galleryBlock + " " + Styles.blockSpace}>
                          <h2>Sponsors</h2>
                          <div className={Styles.galeryContainer}>
                            {filterSponsorsData.map((otherData)=>{
                                return(
                                  <div className={Styles.box} key={otherData._id}>
                                      <figure key={otherData._id}>
                                          <img src={constants.IMAGE_BASE_URL+"/event/"+otherData.image} alt="" />
                                      </figure>
                                      <h3>{otherData.title}</h3>
                                      <p> {parse(`${otherData.embedVideo}`)}</p>
                                  </div>
                                )
                              })}                         
                          </div>
                        </div>
                      )}
                      </>
                      <>
                      {filterSpeakersData && filterSpeakersData.length > 0 &&(
                        <div className={Styles.speakerBlock + " " + Styles.blockSpace}>
                          <h2>Speakers & Panelists</h2>
                          <div className={Styles.spakerTeam}>
                              {filterSpeakersData.map((otherData)=>{
                                      return(
                                      <div className={Styles.box} key={otherData._id}>
                                      <figure>
                                          <img src={constants.IMAGE_BASE_URL+"/event/"+otherData.image} alt="" />
                                      </figure>
                                      <h3>{otherData.title}</h3>
                                      <p> {parse(`${otherData.embedVideo}`)}</p>
                                  </div>
                                      )
                                  
                              })}   
                              
                          </div>
                        </div>)}
                      </>
                      {speakerData && speakerData.length > 0 ? (
                        <div className={`${Styles.speakerBlock} ${Styles.blockSpace}`}>
                          <h2>Speakers & Panelists</h2>
                          <div className={Styles.spakerTeam}>
                            {speakerData.map((otherData) => (
                              <div className={Styles.box} key={otherData._id}>
                                <figure>
                                  <img
                                    src={`${constants.IMAGE_BASE_URL}/event/${otherData.image}`}
                                    alt={otherData.title || 'Speaker'}
                                  />
                                </figure>
                                <h3>{otherData.title}</h3>
                                <p>{parse(otherData.embedVideo)}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}

                      {moderatorData && moderatorData.length > 0 ? (
                        <div className={`${Styles.speakerBlock} ${Styles.blockSpace}`}>
                          <h2>Moderator</h2>
                          <div className={Styles.spakerTeam}>
                            {moderatorData.map((otherData) => (
                              <div className={Styles.box} key={otherData._id}>
                                <figure>
                                      <img src={constants.IMAGE_BASE_URL+"/event/"+otherData.image} alt="" />
                                      </figure>
                                      <h3>{otherData.title}</h3>
                                      <p> {parse(`${otherData.embedVideo}`)}</p>
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      {eventVideoData && eventVideoData.length > 0 ? (
                        <div className={`${Styles.speakerBlock} ${Styles.blockSpace}`}>
                          <h2>Moderator</h2>
                          <div className={Styles.spakerTeam}>
                            {eventVideoData.map((otherData) => (
                              <div className={Styles.videoContainer}  key={otherData._id}>
                                <ReactPlayer url={otherData.embedVideo} />
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      
                    
                      <div
                        className={Styles.socalBlock + " " + Styles.blockSpace}
                      >
                        <h3>Share:</h3>
                        <ul>
                        <li>
                          <a href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank" rel="noopener noreferrer" ><FaFacebookF className={Styles.iconStyle}  /></a>
                        </li>
                        <li>
                           <a href={`https://twitter.com/intent/tweet?url=${currentUrl}&text=${eventDetailData.title}`} target="_blank" rel="noopener noreferrer" ><FaTwitter className={Styles.iconStyle} /></a>
                        </li>
                        <li>
                          <a href={`https://api.whatsapp.com/send?text=${eventDetailData.title}%20${currentUrl}`} target="_blank"    rel="noopener noreferrer"><FaWhatsapp className={Styles.iconStyle} /></a>
                        </li>
                        <li>
                          <a  href={`https://www.linkedin.com/shareArticle?mini=true&url=${currentUrl}&title=${eventDetailData.title}`}  target="_blank" rel="noopener noreferrer" ><FaLinkedinIn className={Styles.iconStyle} /></a>
                        </li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col md={3} className={Styles.wid100}>
                    <div className={Styles.sponsorsSec}>
                      <h2>Sponsors</h2>
                      <div className={Styles.sponsorsLink}>
                        <p>Interested to Sponsor This event?</p>
                        <Link
                          to="/contact"
                          className={Button.greenBtn + " " + Button.greenBtnLg}
                        >
                          Click Here
                        </Link>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            <div className={Styles.recenyEvent}>
              <Container>
                <Row>
                  <Col md={12}>
                    <h3>Related Events:</h3>
                  </Col>
                </Row>
                <Row>
                  {showReltedEvent &&
                    showReltedEvent.slice(0, 3).map((item, index)=>{
                      return(
                        <Col md={4} key={index}>
                          <div className={Styles.mediaList}>
                            <div className={Styles.mediaImg}>
                            {item.image !== "null" ?(
                              <img src={constants.IMAGE_BASE_URL + "event/thumb/" + item.image.replace(/\\/g, '/')} className={Styles.coverImg} />
                              ):( 
                              <img src={require('../../assest/images/no-img.jpg')} className={Styles.coverImg} />
                            )}
                              <Link to={`/event-detail/${item.eventSlug}`} onClick={smoothScroll}  className={Styles.eventTag + " " + Button.brownBtn}>{item.title}</Link>
                            </div>
                            <div className={Styles.mediaDetail}>
                              <h4><Link to={`/event-detail/${item.eventSlug}`}>{item.title}</Link></h4>
                              <div className={Styles.mediaFlex}>
                                <h6>{formatDate(item.eventDate)}</h6>
                                <Link to={`/event-detail/${item.eventSlug}`} onClick={smoothScroll}><IoArrowForwardCircleOutline className={Styles.mediaLink}/>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </Col>
                      )
                    })
                  }
                </Row>
                {showModal && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h2>Confirm Attendance</h2>
                      <p>Please select your attendance status:</p>
                       <div className="d-flex flex-column gap-2">
                      <button
                        className="btn btn-success"
                        onClick={() => handleAttendance("Will Attend")}
                      >
                        Will Attend
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => handleAttendance("May Attend")}
                      >
                        May Attend
                      </button>
                      <button
                        className="btn btn-success"
                        onClick={() => handleAttendance("Will  Not Attend")}
                      >
                        Will Not Attend
                      </button>
                      </div>
                      {/* <button
                        className="btn btn-secondary"
                        onClick={() => setShowModal(false)}
                      >
                        Close
                      </button> */}
                    </div>
                  </div>
                )}
                {showRegistrationCard && (
                  <div className="modal-overlay">
                    <div className="modal-content">
                      <h3>Please Select User Type</h3>
                      <div
                        className="user-option"
                        onClick={() =>
                          handleUserTypeClick("Life Member Alumni",eventDetailData.lifeMemberFee)
                        }
                      >
                        <span>Life Member Alumni</span>
                        <span className="price-tag">₹ {eventDetailData.lifeMemberFee}</span>
                      </div>
                      <div
                        className="user-option"
                        onClick={() =>
                          handleUserTypeClick("Non Life Member Alumni",eventDetailData.nonLifeMemberFee)
                        }
                      >
                        <span>Non Life Member Alumni</span>
                        <span className="price-tag">₹ {eventDetailData.nonLifeMemberFee}</span>
                      </div>
                      <div
                        className="user-option"
                        onClick={() => handleUserTypeClick("Student",eventDetailData.studentFee)}
                      >
                        <span>Student</span>
                        <span className="price-tag">₹ {eventDetailData.studentFee}</span>
                      </div>
                        {/* Form Inputs */}
                          <form className="payment-form beautified-form">
                            <div className="input-group">
                              <label>Amount</label>
                              <input type="text" name="amount" value={form.amount}
                          onChange={handleChange}
                          readOnly />
                            </div>
                            <div className="input-group" style={{ display: "none" }}>
                              <label>Product Info (Event ID)</label>
                              <input type="text" name="productinfo" value={eventDetailData._id} onChange={handleChange} readOnly />
                            </div>
                            <div className="input-group">
                              <label>First Name</label>
                              <input type="text" name="firstname" value={form.firstname} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                              <label>Email</label>
                              <input type="email" name="email" value={form.email} onChange={handleChange} />
                            </div>
                            <div className="input-group">
                              <label>Phone</label>
                              <input type="text" name="phone" value={form.phone} onChange={handleChange} />
                            </div>
                            
                               <button type="submit" onClick={handleSubmitRegister} className="continue-button">
                        Submit
                      </button>

                      <button className="close-button" onClick={closeModal}>
                        Close
                      </button>
                            
                          </form>
                          
                     
                    </div>
                  </div>
                )}
                <AddGuestModal
                  isOpen={isModalOpen}
                  eventDetailData={eventDetailData}
                  onClose={() => setIsModalOpen(false)}
                  handleSubmit={handleSubmit}
                  userType={selectedUserType}
                />
                {isPopupVisible && (
                  <ReviewRegistrationPopup
                    eventDetailData={eventDetailData}
                    isOpen={isPopupVisible}
                    onClose={closePopup}
                    formatDate={formatDate}
                  />
                )}

                <ToastContainer />
              </Container>
              {loginShow && <LoginPopup onClose={loginCloseHandler} /> }
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EventDetailPage;
